module.exports = __webpack_public_path__ + "img/13.0f812746.jpg";